// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".group_form{margin-bottom:15px}.group_form>p{margin-bottom:10px}", "",{"version":3,"sources":["webpack://./src/js/components/common/group-form/RadioGroupForm.scss"],"names":[],"mappings":"AAAA,YACE,kBAAA,CAEA,cACE,kBAAA","sourcesContent":[".group_form {\r\n  margin-bottom: 15px;\r\n\r\n  & > p {\r\n    margin-bottom: 10px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
